// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"ViewPage_modal-scroll__opCO7","TABLET":"ViewPage_TABLET__7mlXu","MOBILE":"ViewPage_MOBILE__LYGLH","container":"ViewPage_container__DgdVm"};